import { connect } from 'react-redux';
import { makeProductEditorDispatcher } from '../../../../../../redux/logo/logo.dispatchers';
import { ProductEditorComponent } from './product-editor';
import { makeProductEditorSelector, hiddenProductEditorSelector } from './connect/product-editor.selector';
export const ProductEditor = connect(makeProductEditorSelector, makeProductEditorDispatcher)(ProductEditorComponent);
export const HiddenProductEditor = connect(hiddenProductEditorSelector, makeProductEditorDispatcher)(ProductEditorComponent);